import React from 'react';
import MUILink from '@mui/material/Link';
import { Link } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { ROUTE_NAMES, withRoot } from '@/core/routes/routeNames';
import tokens from '@/core/tokens.json';

function DashboardBreadCrumbLink() {
  return (
    <MUILink
      key={ROUTE_NAMES.DASHBOARD.DASHBOARD}
      component={Link}
      to={withRoot(ROUTE_NAMES.DASHBOARD.DASHBOARD)}
      underline="hover"
      color="inherit"
    >
      <Typography variant="body2">{tokens.DASHBOARD}</Typography>
    </MUILink>
  );
}

export default DashboardBreadCrumbLink;
